/**
 * A remembered device that has since been unplugged is not a choice any more,
 * and refusing to record over it would be refusing to record at all — so the
 * default microphone takes over, and that is not reported as a failure.
 */
export async function openChosenMicrophone(
  deviceId: string | null,
  constraintsFor: (deviceId: string | null) => MediaTrackConstraints | true,
): Promise<MediaStream> {
  try {
    return await navigator.mediaDevices.getUserMedia({
      audio: constraintsFor(deviceId),
    });
  } catch (caught) {
    if (
      deviceId !== null &&
      caught instanceof Error &&
      caught.name === 'OverconstrainedError'
    ) {
      return navigator.mediaDevices.getUserMedia({ audio: constraintsFor(null) });
    }

    throw caught;
  }
}
